import { createDirtyChecker, compareByPaths } from "../../gvc/testNewForm/createDirtyChecker";
import { inputToVolumeSet } from "../utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToVolumeSet, compareByPaths({
    description: { path: "description" },
    initialCapacity: { path: "spec.initialCapacity" },
    performanceClass: { path: "spec.performanceClass" },
    storageClassSuffix: { path: "spec.storageClassSuffix" },
    fileSystemType: { path: "spec.fileSystemType" },
    snapshots: { path: "spec.snapshots" },
    autoscaling: { path: "spec.autoscaling" },
    mountOptions: { path: "spec.mountOptions" },
    customEncryption: { path: "spec.customEncryption" },
    tags: { path: "tags" },
  }));
}
